import BaseService from "./BaseService";

export default class PamService extends BaseService {

  constructor(self) {
    super(self);
  }

  ConsultaRecalculoPam(parameters) {
    return this.ExecutaFetch("/api/Pam/ConsultaRecalculoPam", "POST", parameters);
  }

  ConsultaTrocaTurmaPam(parameters) {
    return this.ExecutaFetch("/api/Pam/ConsultaTrocaTurmaPam", "POST", parameters);
  }
}